<template>
    <div class="container-base" v-once>

        <div class="page-static-inner">
            <h1 id="quickmail" style="font-size: 140%;">ヤギのメール便利用規約</h1>
            <h2>ヤギのメール便ご利用について</h2>
            <p>株式会社Yagish（以下「当社」といいます）が運営する履歴書等作成サービス「yagish」は、Yagishで作成した履歴書および職務経歴書等を応募先企業の担当者宛てにメール送信し、応募先企業がWEB上で閲覧やPDFでダウンロードできるサービス「ヤギのメール便」（以下「本サービス」といいます）を行っており、当社又は当社が当サイトの運営を委託した者が運営しております。<br>本サービスをご利用の際には、当社が以下に定める内容（以下「本規約」といいます）に従ってご利用ください。また、本サービスのご利用をもって本規約をご承諾いただいたものといたします。当社は、本規約を変更した場合には、別途当社が明示的に定める場合を除き、当該変更についてyagish上で表示するものとし、当該表示の後に本サービスをご利用された場合には、本サービスの利用者（以下「利用者」といいます）が変更後の本規約をご承諾したものとみなし、当社と利用者との間では、変更後の本規約の内容が効力を生じるものといたします。ご利用にあたって利用者は、サービスのご利用に際して関連するすべての法律・法令などを遵守されるものといたします。当サイトの保守（緊急の保守を含みます）のため、事前の通知なしにサービスを停止することがあります。
            </p>
            <h2>利用料金について</h2>
            <p>本サービスを利用する場合は、利用料金を支払うものとし、料金の支払いはクレジットカードを用いるものとします。本サービスの利用料金または支払方法を予告なしに改定することがあります。<br>
                当社は如何なる場合があっても利用代金の減額、返金は行わないものといたします。</p>
            <h2>費用負担について</h2>
            <p>本サービスを利用するために必要となるコンピューター、ソフトウェア、インターネット回線・通信その他これらに付随して必要となる全ての機器、設備及びサービスにかかる費用は、利用者の負担とします。利用者は、自己の費用と責任で、任意の電気通信サービスを経由して本サイトにアクセスし、本サービスを利用するものといたします。
            </p>
            <h2>知的財産権について</h2>
            <p>yagish上に表示され、又は取得し得るすべてのコンテンツ、テキスト、イメージ、データ、ソフトウェア、情報その他の資料（以下「コンテンツなど」といいます）に関する知的財産権（商標権、著作権などのすべての権利を指します。以下「知的財産権」といいます）は、当社又は当社にコンテンツなどを提供している提供元に帰属し、関連する知的財産権に関する法律などにより保護されています。利用者は、本規約及び関連する法律に従って、yagishを利用することができ、また、コンテンツなどをダウンロード及び印刷できます。当社に事前の承諾を受けた場合を除いて、私的使用その他法律によって明示的に認められる範囲を超えてコンテンツなどやそれらに包含される内容（一部か全部かを問いません）を複製・改変・公開・送信・頒布・譲渡・貸与・使用許諾・転載・再利用することはできません。yagish上に掲載される個々の商標・ロゴマーク、商号などに関する権利は、当社又は個々の権利の所有者に帰属します。商標法その他の法律により認められる場合を除き、これらを当社の許諾を得ることなく使用する行為などは商標法などにより禁止されています。
            </p>
            <h2>免責事項について</h2>
            <ul>
                <li>メール送信する履歴書等の資料についてはさまざまな注意を払って管理しておりますが、ご依頼を受けた際の履歴書および職務経歴書の作成内容はご本人の責任でご確認いただき、仮に内容に不備があっても当社は入力内容のままメール送信いたします。
                </li>
                <li>メールの送付先情報（会社名・担当者名・メールアドレス）に入力間違いがあった際の責任は負いません。</li>
                <li>当社は、本サービスに関する利用者の不注意や過失による利用料金の返金はできません。</li>
                <li>yagish上のすべての掲載情報は、あくまでも掲載時点における情報であり、yagish上のすべての掲載情報について、事前に予告することなく名称、内容などの改変や削除をすることがあります。当社は、時間の経過により掲載情報が実際と一致しなくなった場合やサービスの内容を追加又は変更・削除した場合に利用者に生じるいかなる損害に対しても一切責任を負いません。
                </li>
                <li>yagishのアドレスは、トップページを含めて事前に予告することなく変更する場合があります。yagish上の掲載情報の改変・削除やyagishのアドレス変更により発生するリンク切れなど表示に関わる不具合その他一切の影響や利用者に発生する損害について、当社はその責任を負いません。
                </li>
                <li>yagishの保守、火災・停電その他の自然災害、ウィルスや第三者の妨害行為などによる不可抗力によってyagishないし本サービスが停止したことに起因して利用者に生じた損害について、当社は責任を負いません。yagishからリンクされているサイト（以下「リンク先サイト」といいます）について、その掲載情報の正確性、合法性などを当社が保証するものではありません。万一、リンク先サイトの利用につき問題が生じた場合、その責任はリンク先サイトが負っていますので利用者ご自身の責任で対処してください。利用者によるサービスの利用、サービスへの接続、利用者の本規約違反又は利用者による第三者の権利侵害に起因又は関連して生じたすべての苦情や請求については、利用者自身の費用と責任で解決していただくものとし、当社は一切責任を負いません。また、当該苦情や請求への対応に関連して当社に費用が発生（賠償金の支払いを含みます）した場合には、利用者は当該費用を負担するものといたします。
                </li>
                <li>本サービスに関し、当社の責に帰すべき事由により利用者に損害が生じた場合は、当社の利用者に対する損害賠償は利用者から受領した利用料金を上限とするものとします。</li>
            </ul>
            <h2>個人情報などの取り扱いについて</h2>
            <ul>
                <li>サービスのご利用に際して利用者から取得した氏名、メールアドレスなどの個人情報は、別途定める「プライバシーポリシー」に則り取り扱います。</li>
                <li>yagishでは、サイトの利用状況を把握するためにGoogle
                    Analyticsを利用してアクセスログの集計を行っております。アクセスログは、アクセスされた方のドメイン名やIPアドレス、使用しているブラウザの種類、アクセス日時などが含まれますが、個人を識別できる情報を含むものではありません。アクセスログはあくまでも統計的データとして用いるものであり、利用者の個人情報と結びつけることはございません。
                </li>
                <li>Google
                    Analyticsは、クッキー（Cookie、サーバ側で利用者を識別するためにサーバから利用者のブラウザに送信され、利用者のコンピュータに蓄積される情報。以下同じ。）を利用してアクセスログを収集します。収集されるログはGoogle社のプライバシーポリシーに基づいて管理されます。
                    <a href="https://marketingplatform.google.com/about/analytics/?hl=ja" target="_blank">Google
                        Analytics –
                        公式ウェブサイト</a><br><a href="https://policies.google.com/privacy?hl=ja" target="_blank">プライバシー ポリシー
                        – Google
                        ポリシーと規約</a>
                </li>
                <li>yagishでは、利用者の利便性の確保のため、登録サービスなどの一部のサービスに関しましては、クッキーを利用しています。</li>
                <li>yagishでは、個人情報を取り扱うサービスにつきましては、利用者の安全性の確保のためSSL（Secure Socket Layer、暗号通信技術の一種）を利用しています。</li>
                <li>セキュリティについてyagishでは、利用者情報への不正アクセス、紛失、破壊、改ざん、漏えいなどのトラブルを防止するために、セキュリティを高めるための取り組みを継続的に実施していますが、インターネット通信の性質上、サイト利用時には情報漏えいの危険性があることをご了承ください。
                </li>
            </ul>
            <h2>本サービスの終了</h2>
            <p>当社は、相当の周知期間をもってユーザーにWebサイト上で通知の上、利用者に対する本サービスを終了することができるものといたします。ユーザーに対する通知後、本サービスを終了した場合には、利用者に対して本サービスの終了に伴い生じる損害、損失、その他の費用の賠償または補償を免れるものといたします。
            </p>
            <h2>準拠法、裁判管轄</h2>
            <p>本規約の準拠法は日本法とします。また、本サービスまたは本規約に関連して当社と会員の間で生じた紛争については東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
            <p class="text-right">2023年4月9日制定<br>2023年4月10日改訂</p>
            <div class="back-button"><a href="/kr/resume/" class="router-link-active">메인으로</a></div>
        </div>




    </div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
    data: function () {
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    mounted: function () { }
}
</script>
